/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_CloseInputs */

const en_audio_embed_export_close = /** @type {(inputs: Audio_Embed_Export_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_audio_embed_export_close = /** @type {(inputs: Audio_Embed_Export_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_audio_embed_export_close = /** @type {(inputs: Audio_Embed_Export_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_audio_embed_export_close = /** @type {(inputs: Audio_Embed_Export_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vicino`)
};

const ru_audio_embed_export_close = /** @type {(inputs: Audio_Embed_Export_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрывать`)
};

const es_audio_embed_export_close = /** @type {(inputs: Audio_Embed_Export_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const zh_cn2_audio_embed_export_close = /** @type {(inputs: Audio_Embed_Export_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const ja_audio_embed_export_close = /** @type {(inputs: Audio_Embed_Export_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近い`)
};

const hi_audio_embed_export_close = /** @type {(inputs: Audio_Embed_Export_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करना`)
};

const pt_pt2_audio_embed_export_close = /** @type {(inputs: Audio_Embed_Export_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Audio_Embed_Export_CloseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_close = /** @type {((inputs?: Audio_Embed_Export_CloseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_CloseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_close(inputs)
	if (locale === "de") return de_audio_embed_export_close(inputs)
	if (locale === "it") return it_audio_embed_export_close(inputs)
	if (locale === "ru") return ru_audio_embed_export_close(inputs)
	if (locale === "es") return es_audio_embed_export_close(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_close(inputs)
	if (locale === "ja") return ja_audio_embed_export_close(inputs)
	if (locale === "hi") return hi_audio_embed_export_close(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_close(inputs)
	return en_audio_embed_export_close(inputs)
});